<template>
    <div class="home">
        <img class="img" src="@/assets/images/nh/img1.jpg" alt="" srcset="">
        <img class="img" src="@/assets/images/nh/img2.jpg" alt="" srcset="">
        <img class="img" src="@/assets/images/nh/img3.jpg" alt="" srcset="">
        <div class="bannerContent" ref="height1">
            <Banner />
        </div>
    </div>
</template>
      
<script>
import { Toast } from "vant";
import Crypt from "@bluedot-tech/vue-ui/es/utils/crypt";
import Banner from "@/components/home/banner3";

export default {
    components: {
        Banner,
    },
    data() {
        return {
        }
    },
    mounted() {
        this.query = this.$route.query;
        this.initShare();
        // 页面浏览 监测
        this.$dataStatistics({
            page_title: `关于耐恒`,
        },'访问');
    },

    methods: {

    },
};
</script>
<style lang="less" scoped>
.home {
    width: 100%;
    display: flex;
    flex-flow: column;
    
}

.bannerContent {
    width: 100%;
    height: 200px;
    margin: 0 auto 42px;
    background: url('~@/assets/images/nh/swiperbg.png') no-repeat center / 100% 100%;
    width: 375px;
height: 331px;
}
.bannerContent{
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    top: 3700px;
}
.img {
    width: 100%;
    height: auto;
}
</style>
      